import { RACQAddressResult } from '../entities';
import { PartyMatchStatus } from '../entities/roadside-assistance.interface';
import { RoadsideVehicle } from '../entities/roadside-vehicle.interface';

export interface BuyRoadsideDetails {
  vehicle?: RoadsideVehicle;
  personalDetails?: BuyRoadsidePersonalDetails;
  businessDetails?: BuyRoadsideBusinessDetails;

  selectedProductCode?: string;
  partyMatchStatus?: PartyMatchStatus;
  immediateAssistance: boolean | null;
  roadworthyCondition: boolean | null;
}

export interface BuyRoadsidePersonalDetails extends CommonDetails {
  title: string;
  firstName: string;
  lastName: string;
  birthDate: Date;
}

export interface BuyRoadsideBusinessDetails extends CommonDetails {
  businessName: string;
  abn: string;
  acn: string | null | undefined;
}

interface CommonDetails {
  homeAddress?: RACQAddressResult;
  checkPostalAddress: boolean;
  postalAddress?: RACQAddressResult;
  emailAddress: string;
  phoneNumber: string;
}

export const BUSINESS = 'Business';
export const PERSON = 'Person';
